import { Link } from "@chakra-ui/react";
import {
  FaDiscord,
  FaEnvelope,
  FaGithub,
  FaGlobeAmericas,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";

const SocialShare = [
  { Social: <FaGithub />, link: "https://github.com/dcsan" },
  { Social: <FaEnvelope />, link: "mailto:dc+web@rik.ai" },
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/in/dcsan" },
  { Social: <FaGlobeAmericas />, link: "https://dc.rik.ai" },
  { Social: <FaTwitter />, link: "https://twitter.com/dcsan" },
  { Social: <FaDiscord />, link: "https://discord.com/users/dcsan" },
  { Social: <FaInstagram />, link: "https://www.threads.com/@yatayata" },
];
export default function Socials() {
  return (
    <>
      {SocialShare.map((social, index) => (
        <Link key={index} href={social.link} target="_blank">
          {social.Social}
        </Link>
      ))}
    </>
  );
}
